export default __webpack_public_path__ + "static/media/brain.dc221113.png";